<ng-container>
  <form [formGroup]="signUpForm" (ngSubmit)="registerWithEmail()">
    <ion-grid class="ion-margin-bottom">
      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">First name</ion-label>
          <ion-item lines="none">
            <ion-input autocomplete="name" formControlName="{{ formFields.firstName }}"></ion-input>
            <ion-note slot="error">Must not be empty</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Last name</ion-label>
          <ion-item lines="none">
            <ion-input autocomplete="name" formControlName="{{ formFields.lastName }}"></ion-input>
            <ion-note slot="error">Must not be empty</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Email</ion-label>
          <ion-item lines="none">
            <ion-icon name="mail-outline" slot="start"></ion-icon>
            <ion-input
              autocomplete="email"
              formControlName="{{ formFields.email }}"
              inputmode="email"
              type="email"></ion-input>
            <ion-note slot="error">Invalid email</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Phone</ion-label>
          <ion-item lines="none">
            <ion-icon name="call-outline" slot="start"></ion-icon>
            <ion-input autocomplete="tel" formControlName="{{ formFields.telephone }}" inputmode="tel"></ion-input>
            <ion-note slot="error">Invalid telephone number</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Password</ion-label>
          <ion-item lines="none">
            <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
            <ion-input
              autocomplete="new-password"
              formControlName="{{ formFields.password }}"
              placeholder="Make it a good one"
              type="password"></ion-input>
            <ion-note slot="error">Must contain at least 8 characters</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Confirm password</ion-label>
          <ion-item lines="none">
            <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
            <ion-input
              autocomplete="new-password"
              formControlName="{{ formFields.confirmPassword }}"
              placeholder="Make it a good one"
              type="password"></ion-input>
            <ion-note slot="error">Passwords are not equal</ion-note>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="footnote">
          <ion-text>
            By continuing, I am agreeing that I am at least 13 years old and have read and accepted the&#32;
          </ion-text>
          <a class="clickable" href="https://www.rocketcloset.com/terms-of-use">Terms of Use</a>
          <ion-text>&#32;and&#32;</ion-text>
          <a class="clickable" href="https://www.rocketcloset.com/privacy-policy">Privacy Policy</a>
          <ion-text>.</ion-text>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col push="3" size="6">
          <ion-button
            type="submit"
            class="full-width submit-button"
            color="secondary"
            size="large"
            [disabled]="!signUpForm.valid">
            Confirm
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ng-container>
